import {ContactInfo} from "../../pages/contact/ContactInfo";
import ReusableModal from "../ReusableModal";
import React from "react";
import {useAtom} from "jotai";
import {ContactFormAtom} from "../../atoms";

export const ContactFormModal = () => {
  const [contactFormState, setContactFormState] = useAtom(ContactFormAtom);

  const {open, message, title} = contactFormState;

  const handleClose = () => {
    setContactFormState({
      open: false,
      message: "",
      title: ""
    })
  }

  return (
    <ReusableModal open={open} handleClose={handleClose} >
      <ContactInfo message={message || ""} title={title || "Feel free to contact us"} />
    </ReusableModal>
  )
}